module.exports = Email;


//////////////////
// WEBPACK FOOTER
// external "Email"
// module id = 136
// module chunks = 1